import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 118 117",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 118 117\" id=\"icon-play\">\r\n  <g id=\"icon-play_play\" transform=\"translate(-28.195 -28.695)\">\r\n    <ellipse id=\"icon-play_Oval\" cx=\"59\" cy=\"58.5\" rx=\"59\" ry=\"58.5\" transform=\"translate(28.195 28.695)\" fill=\"#f07a3a\" />\r\n    <path id=\"icon-play_Triangle\" d=\"M19.061,0,38.122,25.415H0Z\" transform=\"translate(105.022 68.331) rotate(90)\" fill=\"#fff\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol